export default __webpack_public_path__ + "static/media/GHSI - 2025 GIS SEC Final Acceptance.6889634f.pdf";